var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4"},[(_vm.stepContext)?[_vm._v("Transition durchführen")]:[_vm._v(" Invalid measure step type "),_c('pre',[_vm._v(_vm._s(_vm.stepContext))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }